import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth-service';

export const rolesGuard: CanMatchFn = async (route, _segments) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  // Get required roles from route data
  const requiredRoles = (route.data?.['roles'] as string[]) || [];

  // If no roles are defined, allow access
  if (requiredRoles.length === 0) {
    return true;
  }

  // Attend que l'auth (et donc le profil/les rôles) soit chargée avant de
  // décider — sur un reload de page, le Router évalue ce guard avant que le
  // profil utilisateur ait fini d'arriver, sinon roles() est encore vide.
  await authService.initialize();

  // Check if user has at least one of the required roles
  const userRoles = authService.roles();
  const hasRole = requiredRoles.some((role) => userRoles.includes(role));

  if (!hasRole) {
    return router.createUrlTree(['/']);
  }

  return true;
};
